// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb_root__+oOuS"};